// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import { Icon } from 'components/shared/Icon/Icon'
import styles from './InfoStats.module.scss'

export const InfoStats = ({ label, icon, value, iconClassName }) => {
  return (
    <div className={styles.container}>
      <Icon
        className={cx(styles.icon, { [iconClassName]: Boolean(iconClassName) })}
        icon={icon}
        size={24}
      />
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
    </div>
  )
}
